// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__5o9+U","white":"loader_white__DNU5N","small":"loader_small__aIWGf","lds-ring":"loader_lds-ring__Y0jrD"};